var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({class:`btn btn-` + _vm.color,attrs:{"text":_vm.text,"type":"button"},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_vm._t("loader")]},proxy:true}],null,true)},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }